<template>
  <div class="flex items-center h-full">
    <vs-button
      color="danger"
      icon-pack="feather"
      icon="icon-trash"
      @click="haldleDelete"
    ></vs-button>
  </div>
</template>
<script>
import { delete_users } from '@/api/user'
import { mapActions } from 'vuex'
export default {
  name: 'DeleteActions',
  mounted () {
    this.action = this.params.data.actionData
  },
  data () {
    return {
      action: {}
    }
  },
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_VIEW_LEADS_SIDEBAR',
      'SET_VIEW_LEADS_SIDEBAR_DATA',
      'SET_LEADS_TOGGLE_DATA'
    ]),
    async haldleDelete () {
      const deleting_id = this.params.data.basic_details.operation_user_id
      const payload = {
        deleteField: [deleting_id]
      }
      if (!this.params.data.actionData.toggle) {
        try {
          const customer_id = localStorage.getItem('customer_id')
          const data = await delete_users(payload, customer_id)
          this.SET_DELETE_ID(deleting_id)
          
          this.$vs.notify({
            title: 'Staff Deleted',
            text: 'Staff Deleted Successfully',
            ...this.successProp()
          })
        } catch (error) {
          
        }
      } else {
        this.$vs.notify({
          title: 'Warning',
         text: 'Can\'t remove an active staff. Please deactivate the staff first',
          ...this.warnProp()
        })
      }
      
    }
  }
}
</script>
